import image1 from '../assets/images/Image_fx.jpg'
import image2 from '../assets/images/Image_fx2.jpg'
import image3 from '../assets/images/Image_fx3.jpg'
import image4 from '../assets/images/Image_fx4.jpg'
import image5 from '../assets/images/Image_fx5.jpeg'
import image6 from '../assets/images/Image_fx6.jpg'
import image7 from '../assets/images/Image_fx7.jpg'
import image8 from '../assets/images/Image_fx8.jpg'
import image9 from '../assets/images/Image_fx9.jpg'

const trainers = [
  {
    name: 'Sal Benitez',
    startYear: 2011,
    certifications: [
      'NASM CPT',
      'NASM Corrective Exercise',
      'NASM Fitness Nutrition ',
      'NASM Senior Fitness',
      'NASM Women Fitness',
    ],
    specializations: [
      'Corrective Exercise',
      'Nutritional Guidance',
      'Fat Loss & Body Composition',
      'Injury Prevention',
      'Strength & Conditioning',
      'Longevity Training'
    ],
    degrees: [
      "Bachelor's of Science in Kinesiology",
    ],
    bio: '​I am a movement specialist with a degree in Kinesiology and over 15 years of experience in the fitness industry. My work is dedicated to the science of how the body moves, recovers, and builds strength across the entire human lifespan. ​My approach is built on the reality that fitness is not one-size-fits-all. Every individual is unique, possessing a specific skeletal structure and movement history that requires evidence-based programming rather than trendy social media exercises or generic templates. I integrate my nutrition expertise to ensure your fueling strategy is as precise as your training, moving away from generalized advice to address your specific metabolic and physiological needs.',
    image: image2,
  },
 
  {
    name: 'Shane Napier',
    startYear: 2006,
    specializations: [
    'Personal Training',
    'Strength Training',
    'Mobility & Flexibility',
    'Injury Prevention',
    'Functional Movement',
    'Metabolic Conditioning',
    'Kettlebells',
    'Kickboxing Conditioning',
    'Balance Training (All Ages)',
    'Nutrition Coaching',
    'Recovery Techniques'
  ],
    certifications: ['CEC'],
    bio: 'Shane is a highly experienced personal trainer with over 20 years in the fitness industry and more than 100 hours of continuing education. His extensive background in functional movement, injury prevention, and performance training allows him to create safe, effective, and customized programs for every client. At SNAP Wellness, Shane helps individuals improve mobility, build strength, and increase energy—whether they’re recovering from injury, starting their fitness journey, or training at an advanced level. His approach makes long-term wellness accessible, sustainable, and enjoyable. If you want a more technical, more athlete-focused, or more client-friendly version for different pages (trainer cards vs. full profile), I can tailor it exactly to that use case.',
    image: image3,
  },

 {
    name: 'Craig Gentile',
    startYear: 2019,
    specializations: [
      'Personal Training (All Levels)',
      'Strength & Muscle Development',
      'Functional Training',
      'Military-Inspired Training',
      'Master Personal Traine',
      'Advanced Sports Nutrition ',
    ],
    bio: "Craig is a Marine Corps Veteran and CSULB graduate with over six years of experience helping clients build strength, confidence, and sustainable fitness habits. His disciplined yet supportive approach makes fitness approachable for beginners and effective for experienced athletes alike. After discovering his own passion for training later in life, Craig is driven to help others find their spark and achieve goals they once thought were out of reach—both in and out of the gym. If you want a slightly more friendly or more hype/coach-energy version for a website card or trainer profile carousel, I can tweak it in seconds.",
    image: image4,
    certifications: ['Master Personal Trainer (American Sports & Fitness Association)','Advanced Sports Nutrition (American Sports & Fitness Association)'],
    website: 'https://marcusthompsonfit.com',
    instagram: 'https://instagram.com/marcusthompsonfit',
  },
  {
    name: 'Brian Buzas',
    experience: '2022',
    specializations: ['Prenatal Fitness', 'Postpartum Recovery', 'Core Rehabilitation'],
    certifications: ['International Kettlebell Fitness Federation (CKT)', 'USA Weightlifting Coach (USAW)', 'CrossFit Level 1','NASM (CPT, PES)','ISSA (CPT)'],
    bio: 'Fitness changed my life, and now I help others experience the same transformation. As a personal trainer, I focus on simple, effective workouts and realistic nutrition habits that fit into everyday life. No extremes—just smart training, consistency, and real progress',
    image: image5,
  },
  {
    name: 'Justin Altier',
    experience: '2017',
    certifications: ['National Strength & Conditioning Association (NSCA) Personal Trainer','CNI College, Personal Training'],
    bio: `With over 16 years of experience and a career spanning hundreds of success stories, Justin Altier brings a sophisticated, science-backed approach to the gym floor. A graduate of CNI College's Personal Training program and a student of Dietetics and Nutrition at CSULB, Justin fuses clinical data with practical movement to deliver life-changing results.
Justin's methodology is rooted in meticulous data analysis. He tracks and analyzes every client's metrics to solve complex physical puzzles, identifying dysfunctions and imbalances to restore pain-free movement. By prioritizing mobility and corrective exercise, he ensures that pain never acts as a deterrent to progress.
His diverse portfolio ranges from coaching elite athletes with the Ice Dogs Hockey Team and Lakewood High School to helping general population clients achieve remarkable weight loss milestones—some exceeding 100 pounds. While he specializes in hypertrophy (muscle building) and data-driven fat loss, Justin is known equally for his quirky, personable nature. He believes the training experience should be as informative as it is enjoyable, making high-level science accessible to everyone from 14-year-old athletes to seniors in their 80s.`,
    image: image6,
  },
{
    name: 'Juan Guerrero',
    bio: `I'm a dedicated personal trainer with over 10 years of experience helping clients move better, feel stronger, and perform at their highest level. I specialize in sports rehabilitation and injury recovery, combining evidence-based training methods with corrective exercise strategies to safely rebuild strength, mobility, and confidence. Whether you're an athlete returning to competition or someone recovering from an injury, I create customized, results-driven programs designed to accelerate recovery and optimize performance.
My approach is rooted in functional movement, biomechanics, and progressive strength training to ensure long-term success—not just short-term fixes. I'm passionate about injury prevention, performance enhancement, and empowering my clients through smart, strategic coaching. If you're ready to train with purpose and take control of your recovery journey, I'm here to guide you every step of the way.`,
    image: image7,
  },
 /*     {
    name: 'Alex Turner',
    title: 'Sports Performance Coach',
    experience: '5 Years Experience',
    specializations: ['Speed Training', 'Agility', 'Sport-Specific Training'],
    certifications: ['CSCS', 'USAW Sports Performance'],
    bio: 'Alex works with athletes looking to elevate their game. His expertise in speed, agility, and power development helps athletes gain the competitive edge they need to excel in their sport.',
    image: image8,
    website: 'https://alexturnerfit.com',
    instagram: 'https://instagram.com/alexturnerfit',
  },
  {
    name: 'Olivia Patel',
    title: 'Senior Strength & Conditioning Coach',
    experience: '7 Years Experience',
    specializations: ['Powerlifting', 'Olympic Lifting', 'Strength Development'],
    certifications: ['NSCA-CSCS', 'USAW Level 1'],
    bio: 'Olivia is passionate about teaching proper lifting techniques and building raw strength. Her technical expertise and patient teaching style help clients master complex movements and reach new personal records.',
    image: image9,
    website: 'https://oliviapatelfit.com',
    instagram: 'https://instagram.com/oliviapatelfit',
  } */
];

export default trainers;
